import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07b53e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepTariffs" }
const _hoisted_2 = { class: "StepTariffs__title" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center justify-center mt-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка списка тарифов...", -1))
const _hoisted_5 = {
  key: 2,
  class: "flex flex-col items-center justify-center mt-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "По выбранным пунктам не найдены тарифы", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "StepTariffs__list mt-3"
}
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "flex items-center justify-between mt-1" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepTariffs__title" }, "Тариф", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isTariffSelected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.stepNumber) + ". Выберите тариф", 1),
          (_ctx.opened)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _hoisted_4
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.is_failed)
                  ? (_openBlock(), _createBlock(_component_failed_fetch, {
                      key: 1,
                      class: "border-none mt-3",
                      loading: _ctx.state.is_loading,
                      text: "При получении списка тарифов произошла ошибка",
                      "error-message": _ctx.outsideZoneMessage,
                      "error-url": _ctx.state.failure.error_state.url,
                      "error-status": _ctx.state.failure.error_state.status,
                      onRefresh: _ctx.loadTariffs
                    }, null, 8, ["loading", "error-message", "error-url", "error-status", "onRefresh"]))
                  : _createCommentVNode("", true),
                (_ctx.isEmpty)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                  : _createCommentVNode("", true),
                (_ctx.isCanRenderList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("p", null, " Дистанция: " + _toDisplayString(_ctx.additional_data.distance) + " " + _toDisplayString(_ctx.declOfNum(_ctx.additional_data.distance, ['метр', 'метра', 'метров'])), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "list__item",
                          key: item.id
                        }, [
                          _createElementVNode("p", null, [
                            _createTextVNode(" Общая стоимость за доставку: "),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.price) + " тенге", 1)
                          ]),
                          _createElementVNode("p", null, [
                            _createTextVNode(" Предположительное время доставки: "),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.time) + " " + _toDisplayString(_ctx.declOfNum(item.time, ['минуту', 'минуты', 'минут'])), 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_cheap, {
                                class: _normalizeClass(["small mr-2", {
                                        green: item.transport === 'CAR',
                                        primary: item.transport === 'FOOT',
                                    }])
                              }, {
                                default: _withCtx(() => [
                                  (item.transport === 'CAR')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("Авто")
                                      ], 64))
                                    : (item.transport === 'FOOT')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(" Пеший или велосипед ")
                                        ], 64))
                                      : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              (item.isFastest)
                                ? (_openBlock(), _createBlock(_component_cheap, {
                                    key: 0,
                                    class: "small green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Срочная")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_the_button, {
                              disabled: _ctx.disabled,
                              class: "primary small",
                              onClick: ($event: any) => (_ctx.onSelectTariff(item))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _createTextVNode(" Выбрать ")
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_cheap, {
                class: _normalizeClass(["small mx-2", {
                            green: _ctx.form_state.selected_tariff.transport === 'CAR',
                            primary: _ctx.form_state.selected_tariff.transport === 'FOOT',
                        }])
              }, {
                default: _withCtx(() => [
                  (_ctx.form_state.selected_tariff.transport === 'CAR')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Авто")
                      ], 64))
                    : (_ctx.form_state.selected_tariff.transport === 'FOOT')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Пеший или велосипед ")
                        ], 64))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"]),
              (_ctx.form_state.selected_tariff.isFastest)
                ? (_openBlock(), _createBlock(_component_cheap, {
                    key: 0,
                    class: "small green"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Срочная ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_the_button, {
              class: "second text small",
              disabled: _ctx.disabled,
              onClick: _ctx.resetSelectedTariff
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          (_ctx.isTariffSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("p", null, " Дистанция: " + _toDisplayString(_ctx.additional_data.distance) + " " + _toDisplayString(_ctx.declOfNum(_ctx.additional_data.distance, ['метр', 'метра', 'метров'])), 1),
                _createElementVNode("p", null, [
                  _createTextVNode(" Общая стоимость за доставку: "),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.form_state.selected_tariff.price) + " тенге", 1)
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(" Предположительное время доставки: "),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.form_state.selected_tariff.time) + " " + _toDisplayString(_ctx.declOfNum(_ctx.form_state.selected_tariff.time, [
                                'минуту',
                                'минуты',
                                'минут',
                            ])), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}